import { api, type PaginatedResponse } from './client';

export interface WhitelistEmail {
  id: string;
  email: string;
  ativo: boolean;
  motivo: string | null;
  criado_por: string | null;
  created_at: string;
  updated_at: string;
}

export type WhitelistEmailListResponse = PaginatedResponse<WhitelistEmail>;

export interface WhitelistInterest {
  id: string;
  email: string;
  ip: string | null;
  user_agent: string | null;
  created_at: string;
}

export type WhitelistInterestListResponse = PaginatedResponse<WhitelistInterest>;

export interface WhitelistEmailsParams {
  q?: string;
  ativo?: boolean;
  page?: number;
  page_size?: number;
}

export interface WhitelistInterestParams {
  q?: string;
  page?: number;
  page_size?: number;
}

export async function fetchWhitelistEmails(params: WhitelistEmailsParams = {}): Promise<WhitelistEmailListResponse> {
  const { data } = await api.get<WhitelistEmailListResponse>('/admin/whitelist/emails', { params });
  return data;
}

export async function createWhitelistEmail(payload: { email: string; motivo?: string }): Promise<WhitelistEmail> {
  const { data } = await api.post<WhitelistEmail>('/admin/whitelist/emails', payload);
  return data;
}

export async function updateWhitelistEmail(id: string, payload: { ativo?: boolean; motivo?: string }): Promise<WhitelistEmail> {
  const { data } = await api.patch<WhitelistEmail>(`/admin/whitelist/emails/${id}`, payload);
  return data;
}

export async function deleteWhitelistEmail(id: string): Promise<void> {
  await api.delete(`/admin/whitelist/emails/${id}`);
}

export async function fetchWhitelistInterest(params: WhitelistInterestParams = {}): Promise<WhitelistInterestListResponse> {
  const { data } = await api.get<WhitelistInterestListResponse>('/admin/whitelist/interest', { params });
  return data;
}

export async function promoteWhitelistInterest(id: string): Promise<WhitelistEmail> {
  const { data } = await api.post<WhitelistEmail>(`/admin/whitelist/interest/${id}/promote`);
  return data;
}
